import { isString, singleColorRegex, floatRegex } from '../utils.js';
var isColorString = function (type, testProp) {
  return function (v) {
    return isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp);
  };
};
var splitColor = function (aName, bName, cName) {
  return function (v) {
    var _a;
    if (!isString(v)) return v;
    var _b = v.match(floatRegex),
      a = _b[0],
      b = _b[1],
      c = _b[2],
      alpha = _b[3];
    return _a = {}, _a[aName] = parseFloat(a), _a[bName] = parseFloat(b), _a[cName] = parseFloat(c), _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1, _a;
  };
};
export { isColorString, splitColor };